import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from './components/Header';
import { categoryList } from '../../../../constants/categoryOccasion';
import {
    toggleLeadFormState,
    submitEventForRegistration,
    loadPreLoadedLeadFormData,
    loadLeadFormData,
    fetchLeadFormDataV2,
    loadPostVerificationLeadForm,
    toggleHomeLeadFormState,
} from '../../../../redux/actions/LeadActions';
import leadFormcityOptions from '../../../../constants/leadform/cityOptions.json';
import LeadFormSlide from './components/Slides/LeadFormSlide';
import NotificationWrapper from './components/Notifications/NotificationWrapper';

import {
    getLeadFormData,
    getLeadFormCode,
    getVenueSlideData,
    getActiveTriggerSlide,
    getEventPlanningState,
    getEventRedirectionUrl,
    getPreLoadedLeadFormData,
    getLeadFormLoadingState,
    getLeadCities,
    getLeadOccasions,
    getLeadTriggerFormCode,
    getStaticLeadState,
    getPostVerificationFormData,
    getCurrentSelectedCity,
} from '../../../../redux/selectors/LeadSelectors';

import { connect } from 'react-redux';
import startCase from 'lodash/startCase';
import isEmpty from 'lodash/isEmpty';
import clone from 'lodash/clone';
import kebabCase from 'lodash/kebabCase';
import lowerCase from 'lodash/lowerCase';
import toString from 'lodash/toString';
import truncate from 'lodash/truncate';
import {
    getOTPSentState,
    getSendingOTPState,
    getUpdatingPhoneState,
    getUserPhoneNotEditableState,
    getVerifyingOTPState,
} from '../../../../redux/selectors/EventVerificationSelectors';
import { getEventMadeState, getSelectedVenues } from '../../../../redux/selectors/VenueSelectors';
import {
    getHeavyDate,
    getSelectedEvent,
    getSelectedEventIdFromEvent,
} from '../../../../redux/selectors/EventSelectors';
import {
    getAuthenticatedState,
    getCountryCodeDict,
    getUser,
    getNationState,
} from '../../../../redux/selectors/AppSelectors';
import {
    closeUserPhoneNumber,
    editUserPhoneNumber,
    sendFirstVerificationEmail,
    sendFirstVerificationSms,
    updateUserPhoneNumber,
    verifyEventByPhone,
    verifyOTPCode,
    verifyOTPCodeForEmail,
} from '../../../../redux/actions/EventVerificationActions';
import VerifyEventSlide from './components/Slides/VerifyEventSlide';
import StaticTriggerSlide from './components/Slides/StaticTriggerSlide';
import EventAlreadyPresent from './components/Slides/EventAlreadyPresent';
import {
    fetchHeavyDateBasedOnEvent,
    loadEvent,
    shortlistVenueOnSearchPage,
    updateEvent,
    updateEventFromForm,
} from '../../../../redux/actions/EventActions';
import { getSelectedCity } from '../../../../redux/reducers/HeaderReducers';
import moment from 'moment';
import {
    getCurrentPage,
    loadvmLeadformTimeStats,
    loadVmLeadTrackContent,
} from '../../../../util/vmCookieHandler';
import { loadVmFormCount } from '../../../../util/vmStorageHandler';
import { openVenueListingInNewTab } from '../../../../util/venueListingRedirect';
import { gtmAlert } from '../../../../util/gtmTrigger';
import { newGtmCustomEvent } from '../../../utility/gtmTrigger';
import { getSelectedLeadForm } from '../../../../redux/reducers/LeadReducers';
import {
    processActionForNewOldLeadForm,
    processGtmDatalayer,
    processPageViewForNewOldLeadForm,
} from '../../../LeadForm/leadFormHandler';
import {
    getDevice,
    getLeadFormTriggerCodeForNcr,
    getLeadFormWhatToShowManual,
    getleadType,
} from '../../../../util/leadFormUtility';
import SlidesPostEvent from './components/Slides/SlidesPostEvent';
import { setLeadFormStats } from '../../../../util/vmSearch';
import leadFormBudgetOptions from '../../../../constants/leadform/budgetSlideOption.json';
import venuetypeOptions from '../../../../constants/leadform/venuetypeOption.json';
import weddingVenueTypeOptions from '../../../../constants/leadform/weddingVenueTypeOptions.json';
import socialVenueTypeOptions from '../../../../constants/leadform/socialVenueTypeOptions.json';
import corporateVenueTypeOptions from '../../../../constants/leadform/corporateVenueTypeOptions.json';
import bestTimeToContactMeOptions from '../../../../constants/leadform/bestTimeToContactMe.json';
import areVendorsRequired from '../../../../constants/leadform/doYouRequireOtherVendors.json';
import visitsoonOptions from '../../../../constants/leadform/visitsoonOptions.json';
import corporateNameOption from '../../../../constants/leadform/corporateNameOption.json'
import {
    CATEGORY_CORPORATE,
    CATEGORY_SOCIAL,
    CATEGORY_WEDDING,
} from '../../../../constants/leadFormConstants';
import {
    getSelectedCatagory,
    getSideBarHaveUsCallYouFormStatus,
} from '../../../../redux/selectors/LeadFormSelectors';
import { setSelectedCatagoryType } from '../../../../redux/actions/LeadFormActions';
import { buildUrl, generateMessageId } from '../../../../util/utility';
import { cloneDeep, over } from 'lodash';
import {
    DESTINATION_WEDDING_MODEL,
    MAKE_UP_ARTIST_MODEL,
    MODELS,
    VENUE_CORPORATE_STANALONE,
    VENUE_CORPORATE_STANALONE_GURGAON,
    VENUE_FARIDABAD_STANDLONE,
    VENUE_MODEL,
} from '../../../../constants/constants';
import needWeddingMakeupOptions from '../../../../constants/leadform/needWeddingMakeupOptions.json';
import makeUpArtistPostOtpOptions from '../../../../constants/leadform/makeupArtistTwoOptions.json';
import destinationWeddingBudgetOptions from '../../../../constants/leadform/destinationWeddingBudgetOptions.json';
import destinationWeddingPostOtpSlides from '../../../../constants/leadform/destinationWeddingPostOtpSlides.json';
import destinationWeddingJaipurPostOtpSlides from '../../../../constants/leadform/destinationWeddingJaipurPostOtpSlides.json'
import corporateeventoptions from '../../../../constants/leadform/corporateeventoptions.json';
import ThankyouSegment from './components/ThankyouSegment';
import { createMixPannelCustomEvent } from '../../../utility/mixPanelUtility';
import { createSuperEvent } from '../../../utility/trackingWrapper';
import { CORPORATE_EVENT } from '../../../../constants/VenueExpertconst';
import preferedLocationsSlide from '../../../../constants/leadform/preferedLocationSlide.json';
import doYouNeedLoanSlide from '../../../../constants/leadform/doYouRequireLoan.json';
import {
    eastDelhi,
    faridabad,
    ghaziabad,
    gurgaonWeddingLarge,
    gurgaonWeddingSmall,
    noida,
    northDelhi,
    southDelhi,
    westDelhi,
} from '../../../../constants/leadform/preferedLocationOptions';
import howManyDaysOfWeddingSlide from '../../../../constants/leadform/howManyDaysOfWeddingSlide.json';
import venueCallApi from '../../../../util/apiVenueCaller';

const LEAD_FORM_SELECTED_CITY = ['Gurgaon', 'Delhi', 'Noida'];
const LEAD_FORM_SELECTED_CITY_CODE = ['gurgaon', 'delhi', 'noida','ghaziabad', 'faridabad'];
const NEW_CITIES = ['jaipur', 'banglore','pushkar','alwar', 'palwal'];
const WESTERN_CITIES = ['mumbai', 'pune','pushkar','alwar', 'palwal'];
const POST_SLIDE_VENUE_LEAD_FORM = [
    VENUE_MODEL,
    VENUE_CORPORATE_STANALONE,
    VENUE_CORPORATE_STANALONE_GURGAON,
    VENUE_FARIDABAD_STANDLONE,
];

/** Draft / initial Redux event can have keys but no server id — isEmpty() stays false. Treat as "no event" until _id (or eventid) exists. */
function hasNoCommittedLeadEvent(event) {
    if (event == null || typeof event !== 'object' || Array.isArray(event)) return true;
    const id = event._id ?? event.id ?? event.eventid ?? event.eventId;
    return id == null || id === '';
}

class SliderForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: '',
            notification: {
                message: '',
                timeout: 3,
                msgId: '',
            },
            selectedCategory: '',
            isWhatsappToggled: false,
            isCompleted: false,
        };
    }

    componentDidMount() {
        let overRideForm = this.props.overRideForm;
        let leadform = null;
        let postLeadForm = null;
        if (this.props.leadFormMode === MAKE_UP_ARTIST_MODEL) {
            leadform = this.generatePreloadedMakeupForm();
            postLeadForm = this.genetrateMakeUpArtistPostOtpForm();
        } else if (this.props.leadFormMode === DESTINATION_WEDDING_MODEL) {
              leadform = (overRideForm === 'rajasthan')
            ? this.generateRajasthanDestinationWeddingPreSelectedForm()
            : (this.props.router.pathname === "/get-quotes-destination-in-jaipur")
                ? this.generateDestinationJaipurWeddingPreSelectedForm()
                : this.generateDestinationWeddingPreSelectedForm();
            postLeadForm = (overRideForm === 'jaipur')
            ? this.generateDestinationWeddingJaipurPostOtpForm()
            : this.generateDestinationWeddingPostOtpForm();

        } else if (this.props.leadFormMode === VENUE_CORPORATE_STANALONE) {
            leadform = this.generateCorporateLandingPagePreSelectedForm();
            postLeadForm = this.generatePostVerificationForm(CATEGORY_CORPORATE);
        } else if (this.props.leadFormMode === VENUE_CORPORATE_STANALONE_GURGAON) {
            leadform = this.generateCorporateGurgaonLandingPagePreSelectedForm();
            postLeadForm = this.generatePostVerificationForm(CATEGORY_CORPORATE);
        } else if (
            this.props.leadFormSubMode &&
            this.props.leadFormSubMode == VENUE_FARIDABAD_STANDLONE
        ) {
            leadform = this.generateFaridabadStandalonePreloadedForm();
        }  else if (overRideForm === "mumbai" || (this.props.currentcity && WESTERN_CITIES.includes(this.props.currentcity))) {
            leadform = this.generateMumbaiAndPunePreloadedForm();
        } else if(LEAD_FORM_SELECTED_CITY_CODE.includes(lowerCase(overRideForm))) {
            leadform = this.generateCityPreloadedForm();
        } else if (
                   (this.props.currentcity && NEW_CITIES.includes(this.props.currentcity)) ||
                   overRideForm === 'jaipur' ||
                   overRideForm === 'bangalore' ||
                   overRideForm === 'pushkar' ||
                   overRideForm === 'alwar'  ||
                   overRideForm === 'palwal'
               ) {
                   leadform = this.generateJaipurandBangalorePreloadedForm();
               } else {
                   if (this.props.cities && this.props.occasions) {
                       leadform = this.generatePreloadedForm();
                   }
               }
        if (leadform) {
            this.setState({
                title: leadform.title,
            });
            this.props.dispatch(loadPreLoadedLeadFormData(leadform));
        }
        if (postLeadForm) {
            this.props.dispatch(loadPostVerificationLeadForm(postLeadForm));
        }
    }

    componentDidUpdate(prevProps) {
        if (
            !prevProps.sideBarFormStatus &&
            this.props.sideBarFormStatus &&
            !this.state.isCompleted
        ) {
            this.setState({
                isCompleted: true,
            });
        }
        if (
            hasNoCommittedLeadEvent(prevProps.event) &&
            !hasNoCommittedLeadEvent(this.props.event) &&
            !this.props.event.isVerified &&
            !this.props.event.isOTPSent
        ) {
            this.sendFirstSms();
        }

        const venuePostMode = POST_SLIDE_VENUE_LEAD_FORM.includes(this.props.leadFormMode);
        const postSlidesMissing = !(
            this.props.postVerificationFormData &&
            Array.isArray(this.props.postVerificationFormData.slides) &&
            this.props.postVerificationFormData.slides.length > 0
        );
        const eventVerified = !!this.props.event?.isVerified;
        const postOtpSegmentActive =
            eventVerified && this.props.event?.isLeadFormCompleted !== true;

        if (
            venuePostMode &&
            postSlidesMissing &&
            postOtpSegmentActive &&
            !hasNoCommittedLeadEvent(this.props.event)
        ) {
            const occasion =
                this.props.selectedCategory ||
                this.props.event?.category ||
                this.props.event?.occasion ||
                'wedding';
            const postLeadForm = this.generatePostVerificationForm(occasion, this.props.event);
            if (postLeadForm?.slides?.length > 0) {
                this.props.dispatch(loadPostVerificationLeadForm(postLeadForm));
            }
        }
        //     else if (this.props.leadFormMode === VENUE_CORPORATE_STANALONE) {
        //     let postLeadForm = this.generateCorporatePostVerificationForm();
        //     this.props.dispatch(loadPostVerificationLeadForm(postLeadForm));
        // }

        if (
            !prevProps.isAuthenticated &&
            this.props.isAuthenticated &&
            !isEmpty(this.props.event) &&
            !isEmpty(this.props.selectedVenue)
        ) {
            this.props.dispatch(
                shortlistVenueOnSearchPage(
                    this.props.selectedVenue._id,
                    this.props.selectedVenue.venuecontact,
                    this.props.event._id,
                    this.props.event.bundleId
                )
            );
        }

        if (
            !isEmpty(this.props.event) &&
            !hasNoCommittedLeadEvent(prevProps.event) &&
            this.props.event.isVerified &&
            this.props.event.isLeadFormCompleted
        ) {
            if (this.props.url && this.props.url !== '') {
                if (isEmpty(this.props.selectedVenue)) {
                    this.changeWindowUrl(this.props.url);
                    this.close();
                } else {
                    this.close();
                }
            } else if (this.props.leadFormMode == MAKE_UP_ARTIST_MODEL && !this.state.isCompleted) {
                this.setState({
                    isCompleted: true,
                });
            }  else if (this.props.leadFormMode == DESTINATION_WEDDING_MODEL && !this.state.isCompleted) {
                this.setState({
                    isCompleted: true,
                })
            } else if (this.props.leadFormMode == VENUE_MODEL && !this.state.isCompleted) {
                this.setState({
                    isCompleted: true,
                });
            } else if (
                this.props.leadFormMode == VENUE_CORPORATE_STANALONE &&
                !this.state.isCompleted
            ) {
                this.setState({
                    isCompleted: true,
                });
            } else if (
                this.props.leadFormMode == VENUE_CORPORATE_STANALONE_GURGAON &&
                !this.state.isCompleted
            ) {
                this.setState({
                    isCompleted: true,
                });
            }
            this.close();
        }
    }

    componentWillUnmount() {
        this.props.dispatch(loadPreLoadedLeadFormData({}));
        this.props.dispatch(loadLeadFormData({}));
    }

    changeWindowUrl = (url) => {
        openVenueListingInNewTab(url);
    };

    resetPlanForm = () => {
        this.props.dispatch(loadEvent({}));
        let leadform = this.generatePreloadedForm();
        this.setState({
            title: leadform.title,
        });
        this.props.dispatch(loadPreLoadedLeadFormData(leadform));
    };

    generatePreloadedForm = () => {
        let cityOptions__ = leadFormcityOptions;
        const cityOptions = cityOptions__.map((city, index) => {
            if (index == 0) {
                city.isSelected = true;
            }
            return city;
        });
        let newCityOptions = [];
        if (!isEmpty(this.props.selectedVenue)) {
            let firstCityOptions = [];
            let secondCityOptions = [];
            cityOptions.forEach((item) => {
                if (item.label === startCase(this.props.selectedVenue.city)) {
                    item.isSelected = true;
                    firstCityOptions.push(item);
                } else {
                    item.isSelected = false;
                    secondCityOptions.push(item);
                }
            });
            newCityOptions = newCityOptions.concat(firstCityOptions);
            newCityOptions = newCityOptions.concat(secondCityOptions);
        } else {
            let firstCityOptions = [];
            let secondCityOptions = [];
            cityOptions.forEach((item) => {
                if (item.label === startCase(this.props.selectedCity)) {
                    item.isSelected = true;
                    firstCityOptions.push(item);
                } else {
                    item.isSelected = false;
                    secondCityOptions.push(item);
                }
            });
            newCityOptions = newCityOptions.concat(firstCityOptions);
            newCityOptions = newCityOptions.concat(secondCityOptions);
        }
        let firstOccasionOptions = [];
        let secondOccasionOptions = [];
        let occasionOptions = [];
        categoryList?.forEach((item) => {
            if (kebabCase(item.name) === this.props.leadFormCode) {
                firstOccasionOptions.push({
                    value: item.name,
                    label: startCase(item.name),
                    image: item.imageLink,
                    image_alt_text: item.imageAlt,
                    isImageAvailable: false,
                    isOptionMainOption: false,
                    _id: item._id,
                    isSelected: true,
                    isCustomOccasion: true,
                    occasions: item.occasions,
                });
            } else {
                secondOccasionOptions.push({
                    value: item.name,
                    label: startCase(item.name),
                    image: item.imageLink,
                    image_alt_text: item.imageAlt,
                    isImageAvailable: false,
                    isOptionMainOption: false,
                    _id: item._id,
                    isSelected: false,
                    isCustomOccasion: true,
                    occasions: item.occasions,
                });
            }
        });
        occasionOptions = occasionOptions.concat(firstOccasionOptions);
        occasionOptions = occasionOptions.concat(secondOccasionOptions);
        let citySlide = {
            questionText: 'City',
            _id: this.generateMessageId(10),
            isContinuingSlide: true,
            continueCode: 'occasion-city',
            isTriggerSlide: false,
            elements: [
                {
                    isRequired: true,
                    elementType: 'radio',
                    validationRule: '',
                    isMultiSelectAllowed: false,
                    textLabel: '',
                    textElementName: '',
                    textPlaceholder: '',
                    textIcon: '',
                    defaultValue: '',
                    keyName: 'city',
                    icon: 'fa fa-circle-o',
                    selectedIcon: 'fa fa-check-circle-o',
                    _id: this.generateMessageId(5),
                    dateOptions: [],
                    options: newCityOptions,
                    errorMessage: 'Please Select One City',
                    analyticsTriggerName: 'lead-form-city',
                },
            ],
            isAutoSkipped: true,
            isSkippingAllowed: true,
        };
        let occasionSlide = {
            questionText: 'Occasion',
            _id: this.generateMessageId(10),
            elements: [
                {
                    isRequired: true,
                    elementType: 'radio',
                    validationRule: '',
                    isMultiSelectAllowed: false,
                    textLabel: '',
                    textElementName: '',
                    textPlaceholder: '',
                    textIcon: '',
                    defaultValue: '',
                    keyName: 'category',
                    icon: 'fa fa-circle-o',
                    selectedIcon: 'fa fa-check-circle-o',
                    _id: this.generateMessageId(5),
                    errorMessage: 'Please Select Occasion',
                    dateOptions: [],
                    options: occasionOptions,
                    analyticsTriggerName: 'lead-form-occasion',
                },
            ],
            isAutoSkipped: true,
            isSkippingAllowed: true,
        };
        let preloadForm = {
            title: this.getFormTitle(),
            slides: [],
        };
        if (!isEmpty(this.props.selectedVenue)) {
            occasionSlide.isContinuingSlide = true;
            occasionSlide.continueCode = 'occasion-only';
        }
        preloadForm.slides.push(occasionSlide);
        if (isEmpty(this.props.selectedVenue)) {
            preloadForm.slides.push(citySlide);
        }
        return preloadForm;
    };

    generateJaipurandBangalorePreloadedForm = () => {
        let firstOccasionOptions = [];
        let secondOccasionOptions = [];
        let occasionOptions = [];
        categoryList?.forEach((item) => {
            if (kebabCase(item.name) === this.props.leadFormCode) {
                firstOccasionOptions.push({
                    value: item.name,
                    label: startCase(item.name),
                    image: item.imageLink,
                    image_alt_text: item.imageAlt,
                    isImageAvailable: false,
                    isOptionMainOption: false,
                    _id: item._id,
                    isSelected: true,
                    isCustomOccasion: true,
                    occasions: item.occasions,
                });
            } else {
                secondOccasionOptions.push({
                    value: item.name,
                    label: startCase(item.name),
                    image: item.imageLink,
                    image_alt_text: item.imageAlt,
                    isImageAvailable: false,
                    isOptionMainOption: false,
                    _id: item._id,
                    isSelected: false,
                    isCustomOccasion: true,
                    occasions: item.occasions,
                });
            }
        });
        occasionOptions = occasionOptions.concat(firstOccasionOptions);
        occasionOptions = occasionOptions.concat(secondOccasionOptions);
        let occasionSlide = {
            questionText: 'Occasion',
            _id: this.generateMessageId(10),
            elements: [
                {
                    isRequired: true,
                    elementType: 'radio',
                    validationRule: '',
                    isMultiSelectAllowed: false,
                    textLabel: '',
                    textElementName: '',
                    textPlaceholder: '',
                    textIcon: '',
                    defaultValue: '',
                    keyName: 'category',
                    icon: 'fa fa-circle-o',
                    selectedIcon: 'fa fa-check-circle-o',
                    _id: this.generateMessageId(5),
                    errorMessage: 'Please Select Occasion',
                    dateOptions: [],
                    options: occasionOptions,
                    analyticsTriggerName: 'lead-form-occasion',
                },
            ],
            isAutoSkipped: true,
            isSkippingAllowed: true,
        };
        let preloadForm = {
            title: this.getFormTitle(),
            slides: [],
        };
        occasionSlide.isContinuingSlide = true;
        occasionSlide.continueCode = 'occasion-city';
        preloadForm.slides.push(occasionSlide);
        return preloadForm;
    };

    generateMumbaiAndPunePreloadedForm = () => {
        let firstOccasionOptions = [];
        let secondOccasionOptions = [];
        let occasionOptions = [];
        categoryList?.forEach((item) => {
            if (kebabCase(item.name) === this.props.leadFormCode) {
                firstOccasionOptions.push({
                    value: item.name,
                    label: startCase(item.name),
                    image: item.imageLink,
                    image_alt_text: item.imageAlt,
                    isImageAvailable: false,
                    isOptionMainOption: false,
                    _id: item._id,
                    isSelected: true,
                    isCustomOccasion: true,
                    occasions: item.occasions,
                });
            } else {
                secondOccasionOptions.push({
                    value: item.name,
                    label: startCase(item.name),
                    image: item.imageLink,
                    image_alt_text: item.imageAlt,
                    isImageAvailable: false,
                    isOptionMainOption: false,
                    _id: item._id,
                    isSelected: false,
                    isCustomOccasion: true,
                    occasions: item.occasions,
                });
            }
        });
        occasionOptions = occasionOptions.concat(firstOccasionOptions);
        occasionOptions = occasionOptions.concat(secondOccasionOptions);
        let occasionSlide = {
            questionText: 'Occasion',
            _id: this.generateMessageId(10),
            elements: [
                {
                    isRequired: true,
                    elementType: 'radio',
                    validationRule: '',
                    isMultiSelectAllowed: false,
                    textLabel: '',
                    textElementName: '',
                    textPlaceholder: '',
                    textIcon: '',
                    defaultValue: '',
                    keyName: 'category',
                    icon: 'fa fa-circle-o',
                    selectedIcon: 'fa fa-check-circle-o',
                    _id: this.generateMessageId(5),
                    errorMessage: 'Please Select Occasion',
                    dateOptions: [],
                    options: occasionOptions,
                    analyticsTriggerName: 'lead-form-occasion',
                },
            ],
            isAutoSkipped: true,
            isSkippingAllowed: true,
        };
        let preloadForm = {
            title: this.getFormTitle(),
            slides: [],
        };
        occasionSlide.isContinuingSlide = true;
        occasionSlide.continueCode = 'occasion-city'; // todo fix
        preloadForm.slides.push(occasionSlide);
        return preloadForm;
    };
//for any city other than jaipur, bangalore, mumbai, pushkar, and alwar
    generateCityPreloadedForm = () => {
    let firstOccasionOptions = [];
    let secondOccasionOptions = [];
    let occasionOptions = [];

    categoryList?.forEach((item) => {
        const isMatchingLeadForm = kebabCase(item.name) === this.props.leadFormCode;

        const option = {
            value: item.name,
            label: startCase(item.name),
            image: item.imageLink,
            image_alt_text: item.imageAlt,
            isImageAvailable: false,
            isOptionMainOption: false,
            _id: item._id,
            isSelected: isMatchingLeadForm,
            isCustomOccasion: true,
            occasions: item.occasions,
        };

        if (isMatchingLeadForm) {
            firstOccasionOptions.push(option);
        } else {
            secondOccasionOptions.push(option);
        }
    });

    occasionOptions = [...firstOccasionOptions, ...secondOccasionOptions];

    const occasionSlide = {
        questionText: 'Occasion',
        _id: this.generateMessageId(10),
        elements: [
            {
                isRequired: true,
                elementType: 'radio',
                validationRule: '',
                isMultiSelectAllowed: false,
                textLabel: '',
                textElementName: '',
                textPlaceholder: '',
                textIcon: '',
                defaultValue: '',
                keyName: 'category',
                icon: 'fa fa-circle-o',
                selectedIcon: 'fa fa-check-circle-o',
                _id: this.generateMessageId(5),
                errorMessage: 'Please Select Occasion',
                dateOptions: [],
                options: occasionOptions,
                analyticsTriggerName: 'lead-form-occasion',
            },
        ],
        isAutoSkipped: true,
        isSkippingAllowed: true,
        isContinuingSlide: true,
        continueCode: 'occasion-city', // customizable if needed
    };

    const preloadForm = {
        title: this.getFormTitle(),
        slides: [occasionSlide],
    };

    return preloadForm;
};


    generateFaridabadStandalonePreloadedForm = () => {
        let firstOccasionOptions = [];
        let secondOccasionOptions = [];
        let occasionOptions = [];
        categoryList?.forEach((item) => {
            if (kebabCase(item.name) === this.props.leadFormCode) {
                firstOccasionOptions.push({
                    value: item.name,
                    label: startCase(item.name),
                    image: item.imageLink,
                    image_alt_text: item.imageAlt,
                    isImageAvailable: false,
                    isOptionMainOption: false,
                    _id: item._id,
                    isSelected: true,
                    isCustomOccasion: true,
                    occasions: item.occasions,
                });
            } else {
                secondOccasionOptions.push({
                    value: item.name,
                    label: startCase(item.name),
                    image: item.imageLink,
                    image_alt_text: item.imageAlt,
                    isImageAvailable: false,
                    isOptionMainOption: false,
                    _id: item._id,
                    isSelected: false,
                    isCustomOccasion: true,
                    occasions: item.occasions,
                });
            }
        });
        occasionOptions = occasionOptions.concat(firstOccasionOptions);
        occasionOptions = occasionOptions.concat(secondOccasionOptions);
        let occasionSlide = {
            questionText: 'Occasion',
            _id: this.generateMessageId(10),
            elements: [
                {
                    isRequired: true,
                    elementType: 'radio',
                    validationRule: '',
                    isMultiSelectAllowed: false,
                    textLabel: '',
                    textElementName: '',
                    textPlaceholder: '',
                    textIcon: '',
                    defaultValue: '',
                    keyName: 'category',
                    icon: 'fa fa-circle-o',
                    selectedIcon: 'fa fa-check-circle-o',
                    _id: this.generateMessageId(5),
                    errorMessage: 'Please Select Occasion',
                    dateOptions: [],
                    options: occasionOptions,
                    analyticsTriggerName: 'lead-form-occasion',
                },
            ],
            isAutoSkipped: true,
            isSkippingAllowed: true,
        };
        let preloadForm = {
            title: this.getFormTitle(),
            slides: [],
        };
        occasionSlide.isContinuingSlide = true;
        occasionSlide.continueCode = 'faridabad-stand-alone';

        preloadForm.slides.push(occasionSlide);
        return preloadForm;
    };

    generatePreloadedMakeupForm = () => {
        let personSlide = {
            questionText: 'Who needs the wedding makeup?',
            _id: this.generateMessageId(10),
            elements: [
                {
                    isRequired: true,
                    elementType: 'radio',
                    validationRule: '',
                    isMultiSelectAllowed: false,
                    textLabel: '',
                    textElementName: '',
                    textPlaceholder: '',
                    textIcon: '',
                    defaultValue: '',
                    keyName: 'makeup_person_type',
                    icon: 'fa fa-circle-o',
                    selectedIcon: 'fa fa-check-circle-o',
                    _id: this.generateMessageId(5),
                    errorMessage: 'Please wedding makeup option',
                    dateOptions: [],
                    options: needWeddingMakeupOptions,
                    analyticsTriggerName: 'makeup-form-person-type',
                },
            ],
            isAutoSkipped: true,
            isSkippingAllowed: true,
            isContinuingSlide: true,
            continueCode: 'makeup-form',
        };
        let preloadForm = {
            title: this.getMakeupFormTitle(),
            slides: [],
        };

        preloadForm.slides.push(personSlide);
        return preloadForm;
    };

        generateDestinationJaipurWeddingPreSelectedForm = () => {
         let personSlide = {
            questionText: 'Budget',
            _id: this.generateMessageId(10),
            elements: [
              {
                    isRequired: true,
                    elementType: 'radio',
                    validationRule: '',
                    isMultiSelectAllowed: false,
                    textLabel: '',
                    textElementName: '',
                    textPlaceholder: '',
                    textIcon: '',
                    defaultValue: '',
                    keyName: 'budget',
                    icon: 'fa fa-circle-o',
                    selectedIcon: 'fa fa-check-circle-o',
                    _id: this.generateMessageId(5),
                    errorMessage: 'Please select budget',
                    dateOptions: [],
                    options: destinationWeddingBudgetOptions,
                    analyticsTriggerName: 'lead-form-budget',
                },
            ],
            isAutoSkipped: true,
            isSkippingAllowed: true,
            isContinuingSlide: true,
            continueCode: 'jaipur-destination-wedding-v1',
        };
        let preloadForm = {
            title: this.getDestinationWeddingTitle(),
            slides: [],
        };

        preloadForm.slides.push(personSlide);
        return preloadForm;
    };

    generateDestinationWeddingPreSelectedForm = () => {
         let citySlide = {
            questionText: 'City',
            _id: this.generateMessageId(10),
            elements: [
                 {
          isRequired: true,
          elementType: "radio",
          keyName: "city",
          icon: "icon-vm-radio-black",
          selectedIcon: "icon-vm-radio-active-black",
          validationRule: "",
          isMultiSelectAllowed: false,
          options: [
            { "value": "Gurgaon", "label": "Gurgaon" },
            { "value": "Noida", "label": "Noida" },
            { "value": "Delhi", "label": "Delhi" },
            { "value": "Faridabad", "label": "Faridabad" },
            { "value": "Ghaziabad", "label": "Ghaziabad" }
          ],
          errorMessage: "Please Select One City",
          dateOptions: [],
          analyticsTriggerName: "lead-form-city"
        }
            ],
            isAutoSkipped: true,
            isSkippingAllowed: true,
            isContinuingSlide: true,
            continueCode: 'destination-wedding-v1',
        };
        let preloadForm = {
            title: this.getDestinationWeddingTitle(),
            slides: [],
        };

        preloadForm.slides.push(citySlide);
        return preloadForm;
    };

       generateRajasthanDestinationWeddingPreSelectedForm = () => {
        let citySlide = {
            questionText: 'City',
            _id: this.generateMessageId(10),
            elements: [
                 {
          isRequired: true,
          elementType: "radio",
          keyName: "city",
          icon: "icon-vm-radio-black",
          selectedIcon: "icon-vm-radio-active-black",
          validationRule: "",
          isMultiSelectAllowed: false,
          options: [
            { "value": "Jaipur", "label": "Jaipur" },
            { "value": "Udaipur", "label": "Udaipur" },
            { "value": "Pushkar", "label": "Pushkar" },
            { "value": "Bikaner", "label": "Bikaner" }
          ],
          errorMessage: "Please Select One City",
          dateOptions: [],
          analyticsTriggerName: "lead-form-city"
        }
            ],
            isAutoSkipped: true,
            isSkippingAllowed: true,
            isContinuingSlide: true,
            continueCode: 'destination-wedding-v1',
        };
        let preloadForm = {
            title: this.getDestinationWeddingTitle(),
            slides: [],
        };

        preloadForm.slides.push(citySlide);
        return preloadForm;
    };

    generateCorporateLandingPagePreSelectedForm = () => {
        let personSlide = {
            questionText: 'Corporate Event',
            _id: this.generateMessageId(10),
            elements: [
                {
                    isRequired: true,
                    elementType: 'radio',
                    validationRule: '',
                    isMultiSelectAllowed: false,
                    textLabel: '',
                    textElementName: '',
                    textPlaceholder: '',
                    textIcon: '',
                    defaultValue: '',
                    keyName: 'event',
                    icon: 'fa fa-circle-o',
                    selectedIcon: 'fa fa-check-circle-o',
                    _id: this.generateMessageId(5),
                    errorMessage: 'Please select budget',
                    dateOptions: [],
                    options: corporateeventoptions,
                    analyticsTriggerName: 'lead-form-event',
                },
            ],
            isAutoSkipped: true,
            isSkippingAllowed: true,
            isContinuingSlide: true,
            continueCode: VENUE_CORPORATE_STANALONE,
        };
        let preloadForm = {
            title: this.getCorporateEventTitle(),
            slides: [],
        };

        preloadForm.slides.push(personSlide);
        return preloadForm;
    };

    generateCorporateGurgaonLandingPagePreSelectedForm = () => {
        let personSlide = {
            questionText: 'Corporate Event',
            _id: this.generateMessageId(10),
            elements: [
                {
                    isRequired: true,
                    elementType: 'radio',
                    validationRule: '',
                    isMultiSelectAllowed: false,
                    textLabel: '',
                    textElementName: '',
                    textPlaceholder: '',
                    textIcon: '',
                    defaultValue: '',
                    keyName: 'event',
                    icon: 'fa fa-circle-o',
                    selectedIcon: 'fa fa-check-circle-o',
                    _id: this.generateMessageId(5),
                    errorMessage: 'Please select budget',
                    dateOptions: [],
                    options: corporateeventoptions,
                    analyticsTriggerName: 'lead-form-event',
                },
            ],
            isAutoSkipped: true,
            isSkippingAllowed: true,
            isContinuingSlide: true,
            continueCode: VENUE_CORPORATE_STANALONE_GURGAON,
        };
        let preloadForm = {
            title: this.getCorporateEventTitle(),
            slides: [],
        };

        preloadForm.slides.push(personSlide);
        return preloadForm;
    };

    getVenueTypeSlide = (occasion) => {
        switch (occasion) {
            case CATEGORY_WEDDING:
                return weddingVenueTypeOptions;
            case CATEGORY_CORPORATE:
                return corporateVenueTypeOptions;
            case CATEGORY_SOCIAL:
                return socialVenueTypeOptions;
            default:
                return venuetypeOptions;
        }
    };
    generateVisitUrgencySlide = () => {
        let vistUrgencySlide = cloneDeep(visitsoonOptions);
        let currentTime = moment();
        let timeBefore = moment().set({ hour: 14, minute: 0, second: 0, millisecond: 0 });
        let isBeforeTime = currentTime.isBefore(timeBefore);
        let label = isBeforeTime ? 'Today' : 'In next 1 Day';
        let option = {
            _id: generateMessageId(25),
            value: label,
            label: label,
            isImageAvailable: false,
        };

        vistUrgencySlide?.elements[0]?.options?.unshift(option);
        return vistUrgencySlide;
    };

    getOptionsBasedOnEvent = (category, city, guests, location) => {
        if (city == 'gurgaon') {
            if (lowerCase(category) == CATEGORY_WEDDING && guests >= 200) {
                return gurgaonWeddingLarge;
            } else {
                return gurgaonWeddingSmall;
            }
        } else if (lowerCase(category) == CATEGORY_WEDDING) {
            if (city == 'delhi') {
                switch (location) {
                    case 'south-delhi':
                        return southDelhi;
                    case 'noth-delhi':
                        return northDelhi;
                    case 'west-delhi':
                        return westDelhi;
                    case 'east-delhi':
                        return eastDelhi;
                    case 'central-delhi':
                        return eastDelhi;
                }
            } else if (city == 'noida') {
                return noida;
            } else if (city == 'ghaziabad') {
                return ghaziabad;
            } else if (city == faridabad) {
                return faridabad;
            }
        }
    };

    getPreferedLocationsSlide = (event) => {
        let options = this.getOptionsBasedOnEvent(
            event.event_name,
            event.city,
            event.guests,
            event.region
        );
        if (!options) return undefined;

        let slide = cloneDeep(preferedLocationsSlide);

        slide.elements[0].options = options;

        return slide;
    };

    generatePostVerificationForm = (occasion, event) => {
        const occ = String(
            occasion || event?.category || event?.occasion || 'wedding'
        ).toLowerCase();
        let venueTypeSlide = this.getVenueTypeSlide(occ);
        let preferedLocationSlide = undefined;
        if (event && !isEmpty(event)) {
            preferedLocationSlide = this.getPreferedLocationsSlide(event);
        }
        let howManyDaysSlide = { ...howManyDaysOfWeddingSlide };
        let corporateNameOptions = { ...corporateNameOption}
        let visitUrgencySlide = { ...this.generateVisitUrgencySlide() };
        let vendorRequiredSlide = { ...areVendorsRequired };
        let preloadForm = {
            title: this.getFormTitle(),
            slides: [],
        };

        // if (isEmpty(this.props.selectedVenue)) {
        //     preloadForm.slides.push(venueTypeSlide);
        // }

        // if (preferedLocationSlide && !WESTERN_CITIES.includes(event.city)) {
        //     preloadForm.slides.push(preferedLocationSlide);
        // }

        // occasion.toLowerCase() == CATEGORY_WEDDING && !WESTERN_CITIES.includes(event.city) && preloadForm.slides.push(howManyDaysSlide);
        // !WESTERN_CITIES.includes(event.city) && preloadForm.slides.push(visitUrgencySlide);
        if(occ == CATEGORY_CORPORATE || this.props.leadFormMode === VENUE_CORPORATE_STANALONE || this.props.leadFormMode === VENUE_CORPORATE_STANALONE_GURGAON){
            preloadForm.slides.push(corporateNameOptions);
        }
        preloadForm.slides.push(vendorRequiredSlide);
        if(occ == CATEGORY_WEDDING && event?.city && !WESTERN_CITIES.includes(event.city)) {
            preloadForm.slides.push(howManyDaysSlide);
           }
        // if(occasion.toLowerCase() == CATEGORY_CORPORATE){
        // }   
        // !WESTERN_CITIES.includes(event.city) && preloadForm.slides.push(vendorRequiredSlide);
        // if (occasion.toLowerCase() == CATEGORY_WEDDING) {
        //     !WESTERN_CITIES.includes(event.city) && preloadForm.slides.push(doYouNeedLoanSlide);
        // } 
        // else {
        // }
        let lastSlide = preloadForm.slides[preloadForm.slides.length - 1];
        lastSlide.isContinuingSlide = false;
        lastSlide.isTriggerSlide = true;
        return preloadForm;
    };

    generateCorporatePostVerificationForm = () => {
        let venueTypeSlide = this.getVenueTypeSlide(CATEGORY_CORPORATE);
        let visitUrgencySlide = { ...this.generateVisitUrgencySlide() };
        let bestTimeToContactMeSlide = { ...bestTimeToContactMeOptions };
        let vendorRequiredSlide = { ...areVendorsRequired };
        // todo make the today slide and tomorrow slide possible
        let preloadForm = {
            title: this.getFormTitle(),
            slides: [],
        };

        isEmpty(this.props.selectedVenue) && preloadForm.slides.push(venueTypeSlide);
        preloadForm.slides.push(visitUrgencySlide);
        preloadForm.slides.push(bestTimeToContactMeSlide);
        preloadForm.slides.push(vendorRequiredSlide);

        return preloadForm;
    };

    genetrateMakeUpArtistPostOtpForm = () => {
        let preloadForm = makeUpArtistPostOtpOptions;

        return preloadForm;
    };
    generateDestinationWeddingPostOtpForm = () => {
        let preloadForm = destinationWeddingPostOtpSlides;
        return preloadForm;
    };
    generateDestinationWeddingJaipurPostOtpForm = () => {
        let preloadForm = destinationWeddingJaipurPostOtpSlides;
        return preloadForm;
    };

    getFormTitle = () => {
        if (isEmpty(this.props.selectedVenue)) {
            return `Let Us Plan Your Event`;
        } else {
            return `Get Quote For ${truncate(this.props.selectedVenue.name, 15)}`;
        }
    };

    getMakeupFormTitle = () => {
        return `Get Quote For Bridal Makeup`;
    };

    getDestinationWeddingTitle = () => {
        return `Get Quote For Destination Wedding`;
    };

    getCorporateEventTitle = () => {
        return `Get Quote For Corporate Event`;
    };

    showMessage = (msg, msgtype) => {
        this.notify(msg, 3);
    };

    sendFirstSms = () => {
        if (this.props.event && this.props.event.city === 'dubai') {
            this.props.dispatch(
                sendFirstVerificationEmail(this.props.event._id, this.props.event.contact_email)
            );
        } else {
            this.props.dispatch(
                sendFirstVerificationSms(this.props.event._id, this.props.event.contact_phone)
            );
        }
    };

    verifyEvent = (id, phone) => {
        this.props.dispatch(verifyEventByPhone(id, phone));
    };

    verifyOTP = (id, code) => {
        if (this.props.event && this.props.event.city === 'dubai') {
            this.props.dispatch(verifyOTPCodeForEmail(id, code, this.props.isAuthenticated));
        } else {
            this.props.dispatch(verifyOTPCode(id, code, this.props.isAuthenticated));
        }

        createSuperEvent({
            event_name: `${this.props.pageSource || 'ncr'}-lead-form-otp-verify`,
            btn_label: 'Verify-Otp',
            action_name: 'Verify-Otp-details',
            feature_name: 'lead-form',
            segment_name: 'otp-slide',
        });
        createSuperEvent({
            event_name: `${this.props.pageSource || 'ncr'}-lead-form-otp-verify-${
                this.props.leadFormTriggerCode
            }`,
            btn_label: 'Verify-Otp',
            action_name: 'Verify-Otp',
            feature_name: 'lead-form',
            segment_name: 'otp-slide',
        });

        if (this.props.leadFormTriggerCode && this.props.leadFormTriggerCode !== '') {
            createSuperEvent({
                event_name: `${getLeadFormTriggerCodeForNcr(
                    this.props.selectedVenue,
                    this.props.pageSource,
                    getCurrentPage(),
                    this.props.leadFormMode
                )}-lead-form-otp-verify-${this.props.leadFormTriggerCode}`,
                btn_label: 'Verify-Otp',
                action_name: 'Verify-Otp',
                feature_name: 'lead-form',
                segment_name: 'otp-slide',
            });
            createSuperEvent({
                event_name: `${getLeadFormTriggerCodeForNcr(
                    this.props.selectedVenue,
                    this.props.pageSource,
                    getCurrentPage(),
                    this.props.leadFormMode
                )}-lead-form-otp-verify`,
                btn_label: 'Verify-Otp',
                action_name: 'Verify-Otp',
                feature_name: 'lead-form',
                segment_name: 'otp-slide',
            });
        }
    };

    updatePhone = (id, country_code, contact_phone) => {
        this.props.dispatch(updateUserPhoneNumber(id, country_code, contact_phone));
    };

    editPhone = () => {
        this.props.dispatch(editUserPhoneNumber());
    };

    closeEditPhoneSegment = () => {
        this.props.dispatch(closeUserPhoneNumber());
    };

    handleOccasionChange = (categoryName) => {
        this.setState({
            selectedCategory: categoryName,
        });
        let getLeadFormWhatToShowManualLeadForm = getLeadFormWhatToShowManual();
        const customEvent = {
            category: 'SliderForm',
            action: processActionForNewOldLeadForm(getLeadFormWhatToShowManualLeadForm),
            label: '',
        };
        const gtmPageView2 = processPageViewForNewOldLeadForm(
            getLeadFormWhatToShowManualLeadForm,
            'user'
        );

        const gtm = {
            customEvent,
            gtmPageView2,
        };
        // todo refactor
        processGtmDatalayer(gtm, null);

        let selectedLeadForm = clone(this.props.selectedLeadForm);
        selectedLeadForm.city = !!this.props.selectedCity
            ? lowerCase(this.props.selectedCity)
            : 'gurgaon';
        selectedLeadForm.category = categoryName;
        selectedLeadForm.occasion = '';
        // this.props.dispatch(toggleStaticSlideCrossed(true));
        let leadform = this.generatePreloadedForm();
        this.props.dispatch(loadPreLoadedLeadFormData(leadform));
        // this.props.dispatch(showPreSelectedLeadForm(getLeadFormWhatToShowManualLeadForm, selectedLeadForm, true, '', 'user'));
    };

    notify = (message, timeout) => {
        let notification = this.state.notification;
        notification.message = message;
        notification.timeout = timeout;
        notification.msgId = this.generateMessageId(8);
        this.setState({
            notification: notification,
        });
    };

    rand = (min, max) => {
        let random = Math.random();
        return Math.floor(random * (max - min) + min);
    };

    generateMessageId = (length) => {
        let loopLength = length || 8;
        let allowsChars = '0123456789';
        let password = '';
        for (let index = 0; index < loopLength; ++index) {
            let charIndex = this.rand(0, allowsChars.length - 1);
            password += allowsChars[charIndex];
        }
        return password;
    };

    getParameterByNameForUrl = (name) => {
        let url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };

    checkIfExitsInDataLayer = (gtmEventname) => {
        let exists = false;
        if (window && window.gtmEvents) {
            window.gtmEvents.forEach((item) => {
                if (toString(item) === toString(gtmEventname)) {
                    exists = true;
                }
            });
        }
        return exists;
    };

    submitEvent = (data) => {
        let event = data;
        let phone = event.contact_phone;
        event.contact_phone = phone.phone;
        event.country_code = phone.country_code;
        if (!isEmpty(this.props.selectedVenue)) {
            event.city = this.props.selectedVenue.city_slug;
            event.location = this.props.selectedVenue.sub_area;
            event.region = this.props.selectedVenue.region_slug;
            event.venuetypes = this.props.selectedVenue.propertyType[0];
            event.packagetype = 1;
            event.budget_start = this.props.selectedVenue.veg_show;
            event.budget_end = this.props.selectedVenue.veg_show;
        }
        if (this.props.leadFormSubMode == VENUE_FARIDABAD_STANDLONE) {
            event.city = 'faridabad';
        } else if (this.props.currentcity === 'jaipur') {
            event.city = 'jaipur';
        } else if (this.props.currentcity === 'bangalore') {
            event.city = 'bangalore';
        } else if (this.props.currentcity === 'mumbai') {
            event.city = 'mumbai';
        } else if (this.props.currentcity === 'pune') {
            event.city = 'pune';
        } else if (this.props.currentcity === 'pushkar') {
            event.city = 'pushkar';
        } else if (this.props.currentcity === 'alwar') {
            event.city = 'alwar';
        } else if (this.props.currentcity === 'palwal') {
            event.city = 'palwal';
        } else if (this.props.router.pathname === '/get-quotes-in-gurgaon') {
            event.city = 'gurgaon';
        }else if (this.props.router.pathname === '/get-quotes-in-delhi') {
            event.city = 'delhi';
        } else if (this.props.router.pathname === '/get-quotes-in-ghaziabad') {
            event.city = 'ghaziabad';
        } else if (this.props.router.pathname === '/get-quotes-in-noida') {
            event.city = 'noida';
        } else if (this.props.router.pathname === '/get-quotes-in-faridabad') {
            event.city = 'faridabad';
        } 
         else if (this.props.leadFormSubMode == DESTINATION_WEDDING_MODEL) {
            event.occasion = 'Wedding';
            event.catagory = 'Wedding';
        }
        if (this.props.leadFormMode == VENUE_CORPORATE_STANALONE) {
            event.city = 'delhi';
            event.occasion = 'Corporate';
            event.category = 'Corporate';
        }
        if (this.props.leadFormMode == VENUE_CORPORATE_STANALONE_GURGAON) {
            event.city = 'gurgaon';
            event.occasion = 'Corporate';
            event.category = 'Corporate';
        }
        event.source = this.getParameterByNameForUrl('utm_source');
        event.media = this.getParameterByNameForUrl('utm_medium');
        event.campaign = this.getParameterByNameForUrl('utm_campaign');
        event.other_source = this.getParameterByNameForUrl('gclid');
        event.is_opted_in = this.state.isWhatsappToggled;
        event.useWhatsAppToContactMe = this.state.isWhatsappToggled;
        event.referral = document.getElementById('vmsite-referer-text')
            ? document.getElementById('vmsite-referer-text').value
            : '';
        if (this.props.isAuthenticated) {
            event.user = !isEmpty(this.props.user) ? this.props.user._id : null;
            event.repeatUser = !isEmpty(this.props.user);
        }
        let vmleadformstatscount = loadVmFormCount();
        let vmleadformstatstime = loadvmLeadformTimeStats();
        let stats = {};
        let vmLeadInfo = loadVmLeadTrackContent();
        if (vmLeadInfo) {
            stats = vmLeadInfo;
        }
        const newStats = setLeadFormStats(stats);
        stats = { ...stats, ...newStats };
        stats.path = window.location.pathname;
        stats.leadFillPage = window.location.pathname;
        stats.source_app = `new-${getDevice()}`;
        stats.app_source = 'venuemonk-customer';
        // last_search_budget_min: "2300";
        if (window && window._metaData) {
            stats.ip = window._metaData.ip ? window._metaData.ip : 'none';
            stats.refer_url = window._metaData.referral ? window._metaData.referral : 'none';
        }
        if (vmleadformstatstime) {
            let initialTime = moment(new Date(parseInt(vmleadformstatstime, 10)));
            stats.submitDiff = moment(new Date()).diff(initialTime, 'seconds');
        }
        if (vmleadformstatscount) {
            stats.popupCount = vmleadformstatscount;
        }
        event.leadFormStats = stats;
        createSuperEvent({
            event_name: `${this.props.pageSource || 'ncr'}-lead-form-submit`,
            btn_label: 'Submit',
            action_name: 'submit-details',
            feature_name: 'lead-form',
            segment_name: 'details-slide',
        });
        createSuperEvent({
            event_name: `${this.props.pageSource || 'ncr'}-lead-form-submit-${
                this.props.leadFormTriggerCode
            }`,
            btn_label: 'Submit',
            action_name: 'submit-details',
            feature_name: 'lead-form',
            segment_name: 'details-slide',
        });

        if (this.props.leadFormTriggerCode && this.props.leadFormTriggerCode !== '') {
            createSuperEvent({
                event_name: `${getLeadFormTriggerCodeForNcr(
                    this.props.selectedVenue,
                    this.props.pageSource,
                    getCurrentPage(),
                    this.props.leadFormMode
                )}-lead-form-submit-${this.props.leadFormTriggerCode}`,
                btn_label: 'Submit',
                action_name: 'submit-details',
                feature_name: 'lead-form',
                segment_name: 'details-slide',
            });
            createSuperEvent({
                event_name: `${getLeadFormTriggerCodeForNcr(
                    this.props.selectedVenue,
                    this.props.pageSource,
                    getCurrentPage(),
                    this.props.leadFormMode
                )}-lead-form-submit`,
                btn_label: 'Submit',
                action_name: 'submit-details',
                feature_name: 'lead-form',
                segment_name: 'details-slide',
            });
        }
        if (this.props.leadFormMode == MAKE_UP_ARTIST_MODEL) {
            gtmAlert('makeup_artist_final_submit');
        } else {
            gtmAlert('finalEventSubmitClick');
            gtmAlert('lead_final_event_submit');
            gtmAlert('finalEventSubmitClickNewForm');
        }

        event.isFilledAfterReturnSlide = this.props.userReturnFromExitWindow;

        if (this.props.leadFormMode == MAKE_UP_ARTIST_MODEL) {
            event.lead_source = `v1-${this.props.pageSource || 'mu'}-form-${getDevice()}`;
        }
        if (this.props.leadFormMode == DESTINATION_WEDDING_MODEL) {
            event.lead_source = `v1-${this.props.pageSource || 'dw'}-form-${getDevice()}`;
        } else {
            event.lead_source = `v3-${this.props.pageSource || 'ncr'}-form-${getDevice()}`;
        }
        event.lead_type = getleadType(this.props.leadFormMode);

        this.props.dispatch(submitEventForRegistration(event));
    };

    saveToEvent = (data, finalSubmit = true) => {
        let event = { ...data };
        if (event.areVendorRequired == 'true') {
            event.isPhotographerNeeded = true;
            event.isDecoratorNeeded = true;
            event.isArtistNeeded = true;
        }
        event.is_loan_required = event.is_loan_required == 'true';
        if (finalSubmit) {
            createSuperEvent({
                event_name: `${getLeadFormTriggerCodeForNcr(
                    this.props.selectedVenue,
                    this.props.pageSource,
                    getCurrentPage(),
                    this.props.leadFormMode
                )}-lead-form-save-${this.props.leadFormTriggerCode}`,
                btn_label: 'Submit',
                action_name: 'save-details',
                feature_name: 'lead-form',
                segment_name: 'post-otp-slide',
            });
            createSuperEvent({
                event_name: `${getLeadFormTriggerCodeForNcr(
                    this.props.selectedVenue,
                    this.props.pageSource,
                    getCurrentPage(),
                    this.props.leadFormMode
                )}-lead-form-save`,
                btn_label: 'Submit',
                action_name: 'save-details',
                feature_name: 'lead-form',
                segment_name: 'post-otp-slide',
            });
            createSuperEvent({
                event_name: `${this.props.pageSource || 'ncr'}-lead-form-save-${
                    this.props.leadFormTriggerCode
                }`,
                btn_label: 'Submit',
                action_name: 'save-details',
                feature_name: 'lead-form',
                segment_name: 'post-otp-slide',
            });
            createSuperEvent({
                event_name: `${this.props.pageSource || 'ncr'}-lead-form-save`,
                btn_label: 'Submit',
                action_name: 'save-details',
                feature_name: 'lead-form',
                segment_name: 'post-otp-slide',
            });
        }

        this.props.dispatch(
            updateEventFromForm(this.props.event._id, event, this.props.leadFormMode)
        );
    };

    fetchNextSlide = (code, slideCode, category) => {
        this.props.dispatch(
            fetchLeadFormDataV2(code ? code : this.props.selectedCity, { slideCode, category })
        );
    };

    close = () => {
        if (isEmpty(this.props.event)) {
            this.props.dispatch(toggleLeadFormState(false, '', ''));
            this.props.dispatch(toggleHomeLeadFormState(false, '', ''));
        } else if (this.props.event.isVerified) {
            this.props.dispatch(toggleLeadFormState(false, '', ''));
            this.props.dispatch(toggleHomeLeadFormState(false, '', ''));
        }
    };

    getWhatsappToggleStatus = (val) => {
        this.setState({
            isWhatsappToggled: val,
        });
    };

    setCatagory = (catagory) => {
        this.props.dispatch(setSelectedCatagoryType(catagory));
    };

    fetchHeavyDate = (event) => {
        this.props.dispatch(fetchHeavyDateBasedOnEvent(event));
    };

    fetchLocalitiesOptionBasedOnEvent = async (qtext, appliedLocations) => {
        try {
            if (!qtext || qtext == '') {
                let localitiesOptions = [];
                localitiesOptions = this.getOptionsBasedOnEvent(
                    this.props.event.event_name,
                    this.props.event.city,
                    this.props.event.guests,
                    this.props.event.region
                );
                localitiesOptions.map((option) => {
                    option.isSelected = appliedLocations.some(
                        (filter) => filter.value === option.value
                    );
                    return option;
                });
                return localitiesOptions;
            } else {
                let city = this.props.event.city;
                let region = undefined;

                if (city === 'delhi') {
                    region = this.props.event.location || 'south-delhi';
                }

                let options = {};
                options.queryParams = {};
                if (city) {
                    options.queryParams.city = city;
                }
                if (region) {
                    options.queryParams.region = region;
                }

                let url = buildUrl(`searchbox/subarea/leadform/${qtext}`, options);

                let res = await venueCallApi(url, 'get', undefined, { noApi: true });

                if (res.status === 'Success') {
                    let localitiesOptions = res.data.map((locality) => {
                        let isSelected = appliedLocations.some(
                            (filter) => filter.value === locality.sub_area
                        );

                        return {
                            _id: locality._id,
                            value: {
                                sub_area: locality.sub_area,
                                region: locality.region,
                                city: locality.city,
                            },
                            label: locality.name,
                            isSelected: isSelected,
                            targetKey: 1,
                        };
                    });
                    return localitiesOptions;
                }
            }
        } catch (error) {
            console.log(error, 'eroorr');
            let localitiesOptions = [];
            localitiesOptions = this.getOptionsBasedOnEvent(
                this.props.event.event_name,
                this.props.event.city,
                this.props.event.guests,
                this.props.event.location
            );
            localitiesOptions.map((option) => {
                option.isSelected = appliedLocations.some(
                    (filter) => filter.value === locality.sub_area
                );
                return option;
            });
            return localitiesOptions;
        }
    };

    render() {
        console.log("bhaidadadadadadadadada", this.props.postVerificationFormData);
        let segment;
        if (isEmpty(this.props.event) && isEmpty(this.props.preLoadedLeadFormData)) {
            segment = (
                <StaticTriggerSlide
                    notify={this.notify}
                    selectedCategory={this.state.selectedCategory}
                    handleOccasionChange={this.handleOccasionChange}
                    venueSlideData={this.props.venueSlideData}
                    activeSlide={this.props.activeTriggerSlide}
                />
            );
        } else if (isEmpty(this.props.event) && !isEmpty(this.props.preLoadedLeadFormData)) {
            segment = (
                <LeadFormSlide
                    embeddedLpStyle={this.props.embeddedLpStyle}
                    leadFormMode={this.props.leadFormMode}
                    pageSource={this.props.pageSource}
                    heavyDate={this.props.heavyDate}
                    fetchHeavyDate={this.fetchHeavyDate}
                    selectedVenue={this.props.selectedVenue}
                    selectedCity={this.props.selectedCity}
                    leadFormCode={this.props.leadFormCode}
                    createSuperEvent={createSuperEvent}
                    leadFormTriggerCode={this.props.leadFormTriggerCode}
                    gtmAlert={gtmAlert}
                    newGtmCustomEvent={newGtmCustomEvent}
                    leadFormData={this.props.preLoadedLeadFormData}
                    newLeadFormData={this.props.leadFormData}
                    fetchNextSlide={this.fetchNextSlide}
                    submitEvent={this.submitEvent}
                    isLoadingLeadForm={this.props.isLoadingLeadForm}
                    notify={this.notify}
                    isPlanningEvent={this.props.isPlanningEvent}
                    setTitle={this.setTitle}
                    countryCodeDict={this.props.countryCodeDict}
                    nation={this.props.nation}
                    getWhatsappToggleStatus={this.getWhatsappToggleStatus}
                    setSelectedCatagoryType={this.setCatagory}
                />
            );
        } else if (!isEmpty(this.props.event) && !!!this.props.event.isVerified) {
            segment = (
                <VerifyEventSlide
                    event={this.props.event}
                    phone={this.props.event.contact_phone}
                    country_code={
                        this.props.event.country_code ? this.props.event.country_code : '+91'
                    }
                    email={this.props.event.contact_email}
                    eventId={this.props.eventId}
                    isOTPSent={this.props.isOTPSent}
                    isSendingOTP={this.props.isSendingOTP}
                    isVerifyingOTP={this.props.isVerifyingOTP}
                    isUserPhoneNotEditable={this.props.isUserPhoneNotEditable}
                    editUserPhone={this.editPhone}
                    closeUserPhone={this.closeEditPhoneSegment}
                    verifyEventByPhone={this.verifyEvent}
                    verifyOTPCode={this.verifyOTP}
                    updatePhoneNumber={this.updatePhone}
                    isUpdatingPhone={this.props.isUpdatingPhone}
                    showMessage={this.showMessage}
                />
            );
        } else if (!isEmpty(this.props.event) && !this.props.event.isLeadFormCompleted) {
            // this.props.dispatch(toggleLeadFormState(false, '', ''));
            const postSlideCount =
                this.props.postVerificationFormData &&
                Array.isArray(this.props.postVerificationFormData.slides)
                    ? this.props.postVerificationFormData.slides.length
                    : 0;
            segment = (
                <SlidesPostEvent
                key={`post-otp-${String(
                    this.props.event?._id ||
                    this.props.event?.id ||
                    this.props.eventId ||
                    ''
                )}`} 
                    fetchLocalitiesOptionBasedOnEvent={this.fetchLocalitiesOptionBasedOnEvent}
                    leadFormMode={this.props.leadFormMode}
                    pageSource={this.props.pageSource}
                    selectedVenue={this.props.selectedVenue}
                    selectedCity={this.props.selectedCity}
                    leadFormCode={this.props.leadFormCode}
                    leadFormTriggerCode={this.props.leadFormTriggerCode}
                    gtmAlert={gtmAlert}
                    newGtmCustomEvent={newGtmCustomEvent}
                    createSuperEvent={createSuperEvent}
                    leadFormData={this.props.postVerificationFormData}
                    newLeadFormData={[]}
                    close={this.close}
                    fetchNextSlide={this.fetchNextSlide}
                    saveToEvent={this.saveToEvent}
                    isLoadingLeadForm={this.props.isLoadingLeadForm}
                    notify={this.notify}
                    isPlanningEvent={this.props.isPlanningEvent}
                    setTitle={this.setTitle}
                    countryCodeDict={this.props.countryCodeDict}
                    nation={this.props.nation}
                />
            );
        } else {
            // segment = (
            //     // <EventAlreadyPresent
            //     //     eventId={this.props.event._id}
            //     //     close={this.close}
            //     //     reset={this.resetPlanForm}
            //     // />
            //     null
            // );
            // this.props.dispatch(toggleLeadFormState(false, '', ''));
        }
        return (
            <div>
                          <Header
                    title={this.state.title !== '' ? this.state.title : `Let Us Plan Your Event`}
                    variant={this.props.embeddedLpStyle === 'get-quote' ? 'pinkBanner' : undefined}
                />
                <NotificationWrapper notification={this.state.notification} />
                {this.state.isCompleted || (this.props.event && this.props.event.isLeadFormCompleted) ? (
                    <ThankyouSegment mode={this.props.leadFormMode} />
                ) : (
                    segment
                )}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedCity: getSelectedCity(state),
        isSendingOTP: getSendingOTPState(state),
        isVerifyingOTP: getVerifyingOTPState(state),
        isUserPhoneNotEditable: getUserPhoneNotEditableState(state),
        isUpdatingPhone: getUpdatingPhoneState(state),
        isOTPSent: getOTPSentState(state),
        isEventMade: getEventMadeState(state),
        selectedVenue: getSelectedVenues(state),
        eventId: getSelectedEventIdFromEvent(state),
        event: getSelectedEvent(state),
        isPlanningEvent: getEventPlanningState(state),
        isAuthenticated: getAuthenticatedState(state),
        url: getEventRedirectionUrl(state),
        user: getUser(state),
        isLoadingLeadForm: getLeadFormLoadingState(state),
        leadFormData: getLeadFormData(state),
        preLoadedLeadFormData: getPreLoadedLeadFormData(state),
        postVerificationFormData: getPostVerificationFormData(state),
        leadFormCode: getLeadFormCode(state),
        leadFormTriggerCode: getLeadTriggerFormCode(state),
        venueSlideData: getVenueSlideData(state),
        activeTriggerSlide: getActiveTriggerSlide(state),
        occasions: getLeadOccasions(state),
        cities: getLeadCities(state),
        countryCodeDict: getCountryCodeDict(state),
        nation: getNationState(state),
        selectedLeadForm: getSelectedLeadForm(state),
        selectedCategory: getSelectedCatagory(state),
        sideBarFormStatus: getSideBarHaveUsCallYouFormStatus(state),
        heavyDate: getHeavyDate(state),
        currentcity: getCurrentSelectedCity(state)
    };
}

SliderForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
};

SliderForm.contextTypes = {
    router: PropTypes.object,
};

export default connect(mapStateToProps)(SliderForm);
